const CONVERT_TO_FULL = 'core/postingFull/CONVERT_TO_FULL';
const CONVERT_TO_FULL_COMPLETED = 'core/postingFull/CONVERT_TO_FULL_COMPLETED';
const CONVERT_TO_FULL_FAILED = 'core/postingFull/CONVERT_TO_FULL_FAILED';

export { CONVERT_TO_FULL, CONVERT_TO_FULL_COMPLETED, CONVERT_TO_FULL_FAILED };
